import { useThreadViewers } from "@hooks/threads/useThreadViewers";
import { useUserConfiguration } from "@hooks/useUserConfiguration";
import { Row, Tooltip } from "@narmi/design_system";
import { useMemo } from "react";

export function CurrentViewers({ threadId }: { threadId: string }) {
  const { currentUser } = useUserConfiguration();

  const memoizedThreadId = useMemo(() => [threadId], [threadId]);
  const threadViewers = useThreadViewers(memoizedThreadId);
  const currentThreadViewers = (threadViewers[threadId] || []).filter(
    (viewer) => viewer.uuid !== currentUser.id
  );

  if (!currentThreadViewers.length) {
    return null;
  }

  return (
    <div className="margin--top--m margin--bottom--xxs padding--right--m alignChild--right--top">
      <Tooltip
        text={`Currently viewing: ${currentThreadViewers.map((viewer) => viewer.full_name).join(", ")}`}
      >
        <Row alignItems="center" gapSize="xxs">
          <span className="narmi-icon-eye fontColor--secondary fontSize--xs" />
          <Row.Item>
            <div className="fontColor--secondary fontSize--xs">
              {currentThreadViewers.length === 1
                ? currentThreadViewers[0].full_name
                : `${currentThreadViewers[0].full_name} +${currentThreadViewers.length - 1}`}
            </div>
          </Row.Item>
        </Row>
      </Tooltip>
    </div>
  );
}
